module.exports = __webpack_public_path__ + "img/08-efi-hostinec-zelnak.eac5c13a.jpg";